import { Helmet } from "react-helmet";
import {
    Box,
    Container,
    Grid,
    Button,
    Select,
    MenuItem,
    Divider,
    Paper,
    usePagination,
    TextField,
    InputAdornment,
    ClickAwayListener,
    Collapse,
    Checkbox,
    Autocomplete,
    Typography
} from "@mui/material";
import CircularProgress, {
    circularProgressClasses,
    CircularProgressProps,
} from '@mui/material/CircularProgress';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useMemo, useCallback } from "react";
import { useDispatch } from "react-redux";
import Search from "@mui/icons-material/Search";
import SimpleDialog from "../../../../components/SimpleDialog";
import { ReactComponent as HistoryLF } from "../../../../assets/icons/historyLF.svg";
import { ReactComponent as DownloadResult } from "../../../../assets/icons/downloadResult.svg";
import { ReactComponent as ImportTotal } from "../../../../assets/icons/importTotal.svg";
import { ReactComponent as ImportFail } from "../../../../assets/icons/importFail.svg";
import { ReactComponent as ImportSuccess } from "../../../../assets/icons/importSuccess.svg";
import { ReactComponent as IconImport } from "../../../../assets/icons/import.svg";
import { ReactComponent as Preview } from "../../../../assets/icons/preview.svg";
import { ReactComponent as LaunchFormIcon } from "../../../../assets/icons/launchForm.svg";
import { ReactComponent as Nodata } from "../../../../assets/icons/nodata.svg";
import { ReactComponent as IconXsearch } from "../../../../assets/icons/iconXsearch.svg";
import { ReactComponent as CloseIconLF } from "../../../../assets/icons/closeIconLF.svg";
import { ReactComponent as ChevronExpandDown } from "../../../../assets/icons/chevron-expand-down.svg"
import { ReactComponent as ChevronExpandUp } from "../../../../assets/icons/chevron-expand-up.svg"
import importFilesService from "../../../../services/importFiles.service";
import * as Util from "../../../../services/global.service";
import cssVariables from "../../../../theme/cssVariables";
import { styled } from "@mui/styles";
import debounce from 'lodash.debounce';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { width } from "@mui/system";

const useStyles = makeStyles({
    flexPaper: {
        flex: 1,
        minWidth: 350,
        boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1) !important",
        borderRadius: "10px !important        "
    },
    root: {
        display: 'flex',
        width: "100%",
        flexWrap: 'wrap',
        marginTop: "30px"
    }
});
const styles = {
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
};

const ImportResult = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [checkResired, setCheckRsquired] = React.useState({});
    const [reSet, setreSet] = React.useState(false);
    const [items, setItems] = React.useState([]);
    const [mainItems, setMainItems] = React.useState([]);
    const [dataFilter, setDataFilter] = React.useState({});
    let { serial } = useParams()

    const validationSchema = yup.object({
        code: yup.string().required(t('admin.inputForm.msgError.code')),
        nameEN: yup.string().max(255).required(t('admin.inputForm.msgError.nameTH')),
        descriptionEN: yup.string().max(1000).required(t('admin.inputForm.msgError.nameTH')),
        competencyType: yup.string().max(255).required(t('admin.inputForm.msgError.plessSelect')),
        ratingScaleMaster: yup.string().max(255).required(t('admin.inputForm.msgError.plessSelect')),
    });
    const formik = useFormik({
        initialValues: {
            journey_id: "",
            target_type: "",
            target_group: "",
            target_group_show: {},
            word: "",
            employees: [],
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values) => {
        },
    });

    useEffect(() => {
        importFilesService.getDetail(serial).then((rs) => {
            setMainItems(rs?.data?.err_log)
            setItems(rs?.data)
        }).catch((err) => {

        })
    }, []);

    let setValFilter = (field, data) => {
        if (field === "journey_id") {
            let dt = dataFilter.journeys.find((rs) => rs?.id === data)
            if (Util.formatData(formik.values.target_group,) !== false) {
                formik.setFieldValue("target_group", "")
                formik.setFieldValue("target_group_show", {})
            }
        }
        if (field === "target_group") {
            formik.setFieldValue("target_group", data.id)
            formik.setFieldValue("target_group_show", data)
        } else {
            formik.setFieldValue(field, data)
        }
    }

    let sortData = (key, check1) => {
        let update = checkResired
        if (check1 === false && update[key] !== check1) {
            mainItems.sort(function (b, a) {
                if (a[key] > b[key]) {
                    return -1;
                }
                if (b[key] > a[key]) {
                    return 1;
                }
                return 0;
            });
            update = { [key]: false }
            setCheckRsquired(update)
            setreSet(!reSet)
        } else if (check1 === true && update[key] !== check1) {
            mainItems.sort(function (a, b) {
                if (a[key] > b[key]) {
                    return -1;
                }
                if (b[key] > a[key]) {
                    return 1;
                }
                return 0;
            });
            update = { [key]: true }
            setCheckRsquired(update)
            setreSet(!reSet)
        }
    }

    const openNewTab = (val) => {
        const newWindow = window.open(val, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }

    const clickLink = (data) => {
        navigate(data, { replace: false });
    }
    const exportFile = () => {
        importFilesService.export(serial).then((rs) => {
            window.location = rs.data.file
        }).catch((err) => {

        })
    };

    return (
        <Box style={{ maxHeight: "100%", overflowY: "auto" }}>
            <Helmet>
                <title>Import | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3
                }}
            >
                <Container maxWidth="xl">
                    <Grid container pt={2} pb={2}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A">
                            <span style={styles.link} onClick={() => clickLink('/admin/import')}>Import</span> / <span style={styles.end} >Import Result </span>
                        </Typography>
                    </Grid>
                    <Box>
                        <Box >
                            <Typography variant="h2" color="#404349" fontSize={36} lineHeight="40px" >
                                Import Result
                            </Typography>
                            <Typography pt="20px" fontWeight="500" color="#939393" fontSize={16} lineHeight="17.6px" >
                                File Name: <span style={{ fontWeight: "400", paddingLeft: "15px" }}>{Util.formatData(items?.name, "-")}</span>
                            </Typography>
                            <Typography pt="10px" fontWeight="500" color="#939393" fontSize={16} lineHeight="17.6px" >
                                Template Type: <span style={{ fontWeight: "400", paddingLeft: "15px" }}>{Util.formatData(items?.template, "-")}</span>
                            </Typography>
                            <Typography pt="10px" fontWeight="500" color="#939393" fontSize={16} lineHeight="17.6px" >
                                Cycle: <span style={{ fontWeight: "400", paddingLeft: "15px" }}>{Util.formatData(items?.cycle, "-")}</span>
                            </Typography>
                        </Box>
                        <Box display="flex" py="30px" width="100%">
                            <Box sx={{ width: "calc(33.333% - 20px)" }}>
                                <Box p="20px 30px" width="100%" display="flex" sx={{ background: "#FFFFFF", boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)", borderRadius: "10px", }}>
                                    <Box width="60px" height="60px" sx={{ background: "rgba(64, 67, 73, 0.1)", borderRadius: "100%", }} display="flex" justifyContent="center" alignItems="center">
                                        <ImportTotal />
                                    </Box>
                                    <Box pl="30px">
                                        <Typography fontWeight="600" color="#404349" fontSize={24} lineHeight="26.4px" >
                                            {Util.formatData(items?.total, 0) + " " + "Rows"}
                                        </Typography>
                                        <Typography pt="14px" fontWeight="400" color="#404349" fontSize={18} lineHeight="19.8px" >
                                            Total Rows
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>
                            <Box sx={{ width: "calc(33.333% + 40px)", px: "30px" }}>
                                <Box p="20px 30px" width="100%" display="flex" sx={{ background: "#FFFFFF", boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)", borderRadius: "10px", }}>
                                    <Box width="60px" height="60px" sx={{ background: "rgba(204, 96, 88, 0.1)", borderRadius: "100%", }} display="flex" justifyContent="center" alignItems="center">
                                        <ImportFail />
                                    </Box>
                                    <Box pl="30px">
                                        <Typography fontWeight="600" color="#CC6058" fontSize={24} lineHeight="26.4px" >
                                            {Util.formatData(items?.fail, 0) + " " + "Rows"}
                                        </Typography>
                                        <Typography pt="14px" fontWeight="400" color="#CC6058" fontSize={18} lineHeight="19.8px" >
                                            Fail
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>
                            <Box sx={{ width: "calc(33.333% - 20px)" }}>
                                <Box p="20px 30px" width="100%" display="flex" sx={{ background: "#FFFFFF", boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)", borderRadius: "10px", }}>
                                    <Box width="60px" height="60px" sx={{ background: "#EFF6F4", borderRadius: "100%", }} display="flex" justifyContent="center" alignItems="center">
                                        <ImportSuccess />
                                    </Box>
                                    <Box pl="30px">
                                        <Typography fontWeight="600" color="#5DA196" fontSize={24} lineHeight="26.4px" >
                                            {Util.formatData(items?.success, 0) + " " + "Rows"}
                                        </Typography>
                                        <Typography pt="14px" fontWeight="400" color="#5DA196" fontSize={18} lineHeight="19.8px" >
                                            Success
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }} >
                            <Box>
                                <Typography variant="h2" color="#404349" fontSize={36} lineHeight="40px" >
                                    Error Log
                                </Typography>
                                <Typography pt="8px" color="#AAAAAA" fontSize={14} lineHeight="20.93px" >
                                    The table below will show the error log of uploaded file, you can download the error log at the download result button.
                                </Typography>
                            </Box>
                            <Box sx={{ display: "flex" }} >
                                {items?.can_export &&
                                    <Button onClick={e => exportFile()} sx={{ display: "flex", height: "45px", textTransform: "none", marginLeft: "20px" }} color="primary" variant="contained" >
                                        <Box sx={{ display: "flex", alignItems: "center" }}>
                                            <DownloadResult /><Typography ml="8px" fontSize={16} lineHeight="26.91px" fontWeight="500" color="#FFFFFF">Download Result</Typography>
                                        </Box>
                                    </Button>
                                }
                            </Box>
                        </Box>
                        <div className={classes.root}>
                            <Paper className={classes.flexPaper} >
                                <Box
                                    px="40px"
                                >
                                    <Box
                                        px="25px"
                                        py="19px"
                                        sx={{ display: "flex", flexDirection: "row" }}
                                    >
                                        {/* 18.15 32.2 22.2 17.45 10 */}
                                        <Box sx={{ display: "flex", flexDirection: "row", width: "16%" }} pr="15px">
                                            <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "max-content", marginRight: "10px" }}>
                                                {/* {t('admin.inputForm.code')} */}
                                                Row
                                            </Typography>
                                            <Typography component="span" style={{ flexDirection: "column", justifyContent: "center", "display": "flex" }}>
                                                <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("row", true)} />
                                                <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("row", false)} />
                                            </Typography>
                                        </Box>
                                        <Box sx={{ display: "flex", flexDirection: "row", width: "29%" }} pr="15px">
                                            <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "max-content", marginRight: "10px" }}>
                                                {/* {t('admin.label.employeeName')} */}
                                                Column
                                            </Typography>
                                            <Typography component="span" style={{ flexDirection: "column", justifyContent: "center", "display": "flex" }}>
                                                <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("column", true)} />
                                                <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("column", false)} />
                                            </Typography>
                                        </Box>
                                        <Box sx={{ display: "flex", flexDirection: "row", width: "55%" }} pr="15px">
                                            <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "max-content", marginRight: "10px" }}>
                                                {/* {t('competencyMapping.totalCompetency')} */}
                                                Error Description
                                            </Typography>
                                            <Typography component="span" style={{ flexDirection: "column", justifyContent: "center", "display": "flex" }}>
                                                <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("description", true)} />
                                                <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("description", false)} />
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Divider width="100%" />
                                </Box>
                                {Util.formatData(mainItems, []).length > 0 ? mainItems.map((row, index) =>
                                (
                                    <Box px="40px" key={index}>
                                        <Box sx={{ width: "100%", position: "relative", "&:before": { content: '""', position: 'absolute', height: row?.status === "inactive" ? "100%" : "0px", width: row?.status === "inactive" ? "100%" : "0px", top: "0", background: "#FAFAFA", opacity: "0.7" }, }}>
                                            <Box
                                                sx={{ minHeight: "60px", background: "#FFF", width: "100%", display: "flex", alignItems: "center" }}
                                                px="25px"
                                                py="20px"
                                            >
                                                <Box sx={{ width: "16%", display: "flex", alignItems: "center" }} pr="15px">
                                                    <Typography fontSize={16} lineHeight="23.96px" fontWeight="400" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                        {row?.row === 0 ? "" : Util.formatData(row?.row, "")}
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ width: "29%" }} pr="15px">
                                                    <Typography fontWeight="400" fontSize={16} lineHeight="24px" sx={{ color: "#404349", width: "100%", }}>
                                                        {Util.formatData(row?.column, "")}
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ width: "55%" }} pr="15px">
                                                    <Typography fontWeight="400" fontSize={16} lineHeight="24px" sx={{ color: "#404349", width: "100%", }}>
                                                        {Util.formatData(row?.description, "")}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Box>
                                        <Divider width="100%" />
                                    </Box>
                                ))
                                    :
                                    <Box sx={{ paddingTop: "87px", textAlign: "center", paddingBottom: "143px" }}>
                                        <Nodata />
                                        <Typography color="#A0A0A0" fontWeight="500" fontSize={20} lineHeight="30px" >
                                            No data found
                                        </Typography>
                                    </Box>
                                }
                            </Paper>
                        </div>
                    </Box>
                </Container>
            </Box>
        </Box>
    );
};
export default ImportResult;
